import { getUrlInventoryApi } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import HttpService from './HttpService';

const httpService = new HttpService(getUrlInventoryApi(window));

export default class PartNumberService {
    static getPartNumber(code, callback) {
        const url = '/partnumber';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: { code } }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }
}
